import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
  };

  return (
    <section id="ranking" className="w-full py-12 md:py-16 bg-background-100/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 tracking-wide">
            热度榜单
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            全网热播影视排行榜，看看大家都在追什么
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
            {rankingItems.map((item, idx) => (
              <a
                key={item.rank}
                href="#ranking"
                onClick={handleClick}
                className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3 md:py-4 cursor-pointer no-underline hover:bg-background-100/70 transition-colors ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
                }`}
              >
                <div
                  className={`w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-medium text-foreground-800 truncate">
                      {item.title}
                    </span>
                    <span
                      className={`px-1.5 py-0.5 text-xs rounded font-medium whitespace-nowrap ${
                        item.tag === '热播'
                          ? 'bg-primary-100 text-primary-700'
                          : item.tag === '新上'
                          ? 'bg-accent-100 text-accent-700'
                          : item.tag === '高分'
                          ? 'bg-secondary-100 text-secondary-700'
                          : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      {item.tag}
                    </span>
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">{item.type}</div>
                </div>

                <span className="text-xs md:text-sm text-accent-600 font-medium whitespace-nowrap">
                  {item.hot}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}